module.exports = __webpack_public_path__ + "static/media/read.23157305.svg";